import * as yup from "yup";
import React, { useCallback } from "react";
import { useFormik } from "formik";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";

import CloseIcon from "@material-ui/icons/Close";

import Dialog from "./shared/Dialog";
import DialogActions from "./DialogActions";
import OutlinedButton from "./OutlinedButton";
import useModal from "../hooks/useModal";
import HiDeepLinkSelect from "./shared/HiDeepLinkSelect";

const validationSchema = yup.object().shape({
  hiDeepLink: yup.string().required(),
});

const CopyHiDeepLinkModal = ({ onConfirm, onClose } = {}) => {
  const { handleConfirm } = useModal({
    onClose,
    onConfirm,
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      hiDeepLink: "hicoach",
    },
    onSubmit: async (values) => {
      await handleConfirm(values);
    },
    validationSchema,
    validator: () => ({}),
  });

  const handleHiDeepLinkChange = useCallback(
    (value) => {
      formik.setFieldValue("hiDeepLink", value);
      formik.setFieldTouched("hiDeepLink", true);
    },
    [formik]
  );

  return (
    <Dialog fullWidth open maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          Select HiDeepLink
          <div>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <HiDeepLinkSelect
                defaultValue="hicoach"
                label="HiDeepLink"
                name="hiDeepLink"
                onChange={(e) => handleHiDeepLinkChange(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={formik.handleSubmit}
        >
          Confirm
        </Button>
        <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
      </DialogActions>
    </Dialog>
  );
};

export default CopyHiDeepLinkModal;
